module.exports = __webpack_public_path__ + "img/jl.67e2ef04.png";